import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import Icon from "@/components/icon/Icon.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import BigButton from "@/components/buttons/BigButton.vue";
import WInput from "@/components/form/w-input.vue";
import axios from "axios";
import { alertError } from "@/util/dialog";
import Loader from "@/components/loader/Loader.vue";
import { waitingJob } from "@/util/job.utils";
import LightButton from "@/components/buttons/LightButton.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import AIChapterContentGenerator from "@/components/aiSpeachGenerator/AIChapterContentGenerator.vue";
import { toSpeachEditingPage } from "@/util/routeUtil";
import AISpeachGeneratorPanelOption from "@/components/aiSpeachGenerator/AISpeachGeneratorPanelOption.vue";
import delay from "delay";
let AIStepsGenerator = class AIStepsGenerator extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "aiFiles", []);
    _defineProperty(this, "uploadedFiles", []);
    _defineProperty(this, "language", void 0);
    _defineProperty(this, "duration", void 0);
    _defineProperty(this, "specificPrompt", void 0);
    _defineProperty(this, "allowReorder", void 0);
    _defineProperty(this, "weetEndpoint", void 0);
    _defineProperty(this, "languageSelected", "");
    _defineProperty(this, "durationSelected", "");
    _defineProperty(this, "specificPromptSelected", "");
    _defineProperty(this, "allowReorderSelected", false);
    _defineProperty(this, "openElement", []);
    _defineProperty(this, "generationInProgress", true);
    _defineProperty(this, "showOptionPanel", false);
    _defineProperty(this, "speachGenerated", null);
    _defineProperty(this, "speachToMap", null);
    _defineProperty(this, "indexLecon", -1);
    _defineProperty(this, "indexChapter", -1);
    _defineProperty(this, "weetIDMap", {});
  }
  mounted() {
    this.languageSelected = this.language;
    this.durationSelected = this.duration;
    this.allowReorderSelected = this.allowReorder;
    this.specificPromptSelected = this.specificPrompt;
    this.generateLLMSteps();
  }
  generateLLMSteps() {
    this.generationInProgress = true;
    const formData = new FormData();
    this.aiFiles.forEach(el => {
      formData.append('jobIDs', el.jobID);
    });
    formData.append("language", this.languageSelected);
    formData.append("duration", this.durationSelected);
    formData.append("specificPrompt", this.specificPromptSelected);
    formData.append("allowReorder", this.allowReorderSelected + "");
    axios.post('/recorder/aiSpeachGenerator/generateSteps', formData).then(async resp => {
      this.waitStepGenerationProceed(resp.data);
    }).catch(e => {
      this.generationInProgress = false;
      console.error(e);
      alertError(this.$t('aiContent.error'));
    });
  }
  openAllElement() {
    this.openElement = [];
    if (this.speachGenerated) {
      let i = 0;
      for (const chapter of this.speachGenerated?.chapters) {
        this.openElement.push("chapter" + i);
        i++;
      }
    }
  }
  regenerate() {
    this.showOptionPanel = false;
    this.generateLLMSteps();
  }
  async waitStepGenerationProceed(jobID) {
    try {
      const data = await waitingJob(jobID);
      this.speachGenerated = data;
      this.openAllElement();
      this.generationInProgress = false;
    } catch (e) {
      console.error(e);
      alertError(this.$t('aiContent.error'));
    }
  }
  updateDocumentSpeachGenerated() {
    // Associate subchapter.documentPage.jobID with aiFile.jobID based on document name
    if (!this.speachGenerated || !this.aiFiles || this.aiFiles.length === 0) return;
    // Loop through all chapters and subchapters
    for (const chapter of this.speachGenerated.chapters) {
      for (const subchapter of chapter.subchapters) {
        // Process each document page in the subchapter
        for (const documentPage of subchapter.documentPages) {
          // Extract document index from document name (e.g., document_1 → index 1)
          const documentNameParts = documentPage.documentName.split('_');
          if (documentNameParts.length >= 2) {
            const documentIndex = parseInt(documentNameParts[1]);
            // Find the corresponding AI file (adjusting for 0-based array index)
            const aiFile = this.aiFiles[documentIndex - 1];
            if (aiFile) {
              // Associate job IDs
              documentPage.jobID = aiFile.jobID;
            }
          }
        }
      }
    }
  }
  async validateAiSpeach(goToEditing) {
    if (this.speachToMap) {
      document.location = toSpeachEditingPage(this.speachToMap.speachID);
    } else {
      this.updateDocumentSpeachGenerated();
      this.generationInProgress = true;
      axios.post('/recorder/aiSpeachGenerator/validateSteps', this.speachGenerated).then(async resp => {
        this.speachToMap = resp.data;
        if (goToEditing) {
          document.location = toSpeachEditingPage(this.speachToMap.speachID);
        } else {
          // TODO add speachID to URL
        }
        await delay(1000);
        this.generationInProgress = false;
      }).catch(e => {
        console.error(e);
        alertError(this.$t('aiContent.error'));
      });
    }
  }
  async launchChapterGeneration(indexChapter, indexSubchapter) {
    if (!this.speachToMap) {
      return;
    }
    this.indexLecon = indexChapter;
    this.indexChapter = indexSubchapter;
  }
  onCloseContentGeneration(data) {
    // Handle both string (for backward compatibility) and object formats
    let weetID;
    let mappingInfo = null;
    if (typeof data === 'string') {
      weetID = data;
    } else {
      weetID = data.weetID;
      mappingInfo = data;
    }
    // Store the weetID in the map
    this.weetIDMap[this.indexLecon + "-" + this.indexChapter] = weetID;
    // If we have mapping info, ensure the chapter ID is mapped in speachGenerated
    if (mappingInfo && this.speachGenerated && this.indexLecon >= 0 && this.indexChapter >= 0) {
      if (this.speachGenerated.chapters[this.indexLecon] && this.speachGenerated.chapters[this.indexLecon].subchapters[this.indexChapter]) {
        const generatedSubchapter = this.speachGenerated.chapters[this.indexLecon].subchapters[this.indexChapter];
        // Update chapterID if available in the mapping info
        if (mappingInfo.speachChapterId) {
          generatedSubchapter.chapterID = mappingInfo.speachChapterId;
          console.log(`Updated chapter ID mapping for chapter ${this.indexLecon + 1}.${this.indexChapter + 1}: ${mappingInfo.speachChapterId}`);
        }
      }
    }
    // Reset indices
    this.indexChapter = -1;
    this.indexLecon = -1;
  }
  getWeetIdForChapter(indexlecon, indexChapter) {
    return this.weetIDMap[indexlecon + "-" + indexChapter];
  }
  getOriginalFileForName(name) {
    const indexDoc = name.split("_")[1];
    if (indexDoc) {
      const index = parseInt(indexDoc, 10);
      return this.uploadedFiles[index - 1];
    }
    return null;
  }
  getDocumentForName(name) {
    const indexDoc = name.split("_")[1];
    if (indexDoc) {
      const index = parseInt(indexDoc, 10);
      return this.aiFiles[index - 1];
    }
    return null;
  }
  getPageImage(page) {
    const doc = this.getDocumentForName(page.documentName);
    if (doc && doc.data.length > page.pageNumber - 1) {
      return "data:image/jpeg;base64," + doc.data[page.pageNumber - 1].imageB64;
    }
    return "";
  }
  prevSlide(ref) {
    // @ts-ignore
    this.$refs[ref][0].prev();
  }
  nextSlide(ref) {
    // @ts-ignore
    this.$refs[ref][0].next();
  }
  onDurationChange(value) {
    this.durationSelected = value;
  }
  onLanguageChange(value) {
    this.languageSelected = value;
  }
  onAllowReorder(value) {
    this.allowReorderSelected = value;
  }
  onSpecificPromptChange(value) {
    this.specificPromptSelected = value;
  }
};
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "aiFiles", void 0);
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "uploadedFiles", void 0);
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "language", void 0);
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "duration", void 0);
__decorate([Prop({
  default: ""
})], AIStepsGenerator.prototype, "specificPrompt", void 0);
__decorate([Prop({
  default: true
})], AIStepsGenerator.prototype, "allowReorder", void 0);
__decorate([Prop({
  required: true
})], AIStepsGenerator.prototype, "weetEndpoint", void 0);
AIStepsGenerator = __decorate([Component({
  components: {
    AISpeachGeneratorPanelOption,
    AIChapterContentGenerator,
    WDialog,
    IconButton,
    LightButton,
    Loader,
    WInput,
    BigButton,
    StandardButton,
    Icon
  }
})], AIStepsGenerator);
export default AIStepsGenerator;